// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__jMUMp","logo":"Navbar_logo__ZRnU2","info":"Navbar_info__9RXAn","infoTitle":"Navbar_infoTitle__UwwH2","time":"Navbar_time__L1mUs"};